import brandConfig from './brands/bigBobsBakers/index';

export default brandConfig;